import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../../services/login-service';
import { HttpService } from '../../utility/http-service';

interface HomeStats {
  pendingUsers: number | null;
  totalUsers:   number | null;
  totalClients: number | null;
}

@Component({
  selector: 'app-wc-home',
  templateUrl: './wc-home.component.html',
  styleUrl: './wc-home.component.css',
  standalone: false
})
export class WcHomeComponent implements OnInit {

  stats: HomeStats | null = null;
  statsLoading = true;

  constructor(
    public loginService: LoginService,
    private http: HttpService
  ) {}

  async ngOnInit() {
    this.stats = await this.http.getWait<HomeStats>('HomeStats/GetStats', true, false) ?? null;
    this.statsLoading = false;
  }

  get displayName(): string {
    const u = this.loginService.userOptional;
    if (!u) return '';
    const full = `${u.firstName ?? ''} ${u.lastName ?? ''}`.trim();
    return full || u.userName || '';
  }

  get greeting(): string {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 17) return 'Good afternoon';
    return 'Good evening';
  }

  get showStats(): boolean {
    const u = this.loginService.userOptional;
    return !!(u?.isGlobalAdmin || u?.isCompanyAdmin);
  }
}
